import { render, staticRenderFns } from "./ModalPixKeyOwnerConfirmation.vue?vue&type=template&id=7cf2bd14&"
import script from "./ModalPixKeyOwnerConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalPixKeyOwnerConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ModalPixKeyOwnerConfirmation.vue?vue&type=style&index=0&id=7cf2bd14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports